module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-new-export-icon.d23eb86b.svg";